import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import EmailVerificationModal from "../../Components/email-link-popup/email-link-popup";

export default function NoMatchSection({
  nearestStrategies,
  fromGuest,
  showInvest,
}) {
  const colors = ["#3B82F6", "#06B6D4", "#6366F1", "#10B981"];
  const navigate = useNavigate();
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPortfolio, setSelectedPortfolio] = useState(null);
  const [email, setEmail] = useState("");
  const [file, setFile] = useState(null);
  const [userName, setUserName] = useState("");
  const [selectedCode, setSelectedCode] = useState("");
  const [focus, setFocus] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");

  const [emailSent, setEmailSent] = useState(false);
  const handlePortfolioClick = (portfolio) => {
    setSelectedPortfolio(portfolio);
    setIsModalOpen(true);
  };

  const handleSendLink = () => {
    // Simulate email send

    if (email && /\S+@\S+\.\S+/.test(email)) {
      // TODO: Replace this with API call
      setEmailSent(true);
    }
  };
  const handleCodeChange = (e) => {
    setSelectedCode(e.target.value);
  };
  return (
    <div className="bg-white mt-4 p-4 rounded-2xl shadow border border-gray-100 text-gray-900">
      {/* Empty Match Message */}
      <div className="text-center flex flex-col items-center">
        <img
          src="/warning-circle.svg"
          alt="Add Template Icon"
          className="h-10 w-10"
        />
        <h3 className="text-lg font-semibold text-black mb-1 mt-2">
          No Recommended Strategies Found
        </h3>
        <p className="text-sm text-gray-800 max-w-md">
          Your uploaded stocks do not match any strategy. However, here are the
          nearest matches based on your inputs.
        </p>
      </div>

      {/* Nearest Strategies */}
      <div className="mt-8">
        <h4 className="text-sm font-semibold text-black mb-3">
          Nearest Matching Strategies
        </h4>
        <div className="grid sm:grid-cols-2 gap-4">
          {nearestStrategies.map((strategy) => (
            <div
              key={strategy.strategy_id}
              className="p-4 border rounded-xl bg-white shadow-sm hover:shadow-md transition-shadow flex flex-col justify-between"
            >
              {/* Header Info */}
              <div className="flex items-start justify-between gap-2 mb-2">
                <div className="text-xs text-gray-600">
                  Ref: {strategy.ref_code}
                </div>
                <div className="text-xs font-semibold text-[#34C046] text-right whitespace-nowrap">
                  Matched:{" "}
                  {strategy.overall_matching_percentage
                    ? strategy.overall_matching_percentage.toFixed(2)
                    : "00.00"}
                  %
                </div>
              </div>

              {/* Portfolio Name */}
              <div
                onClick={() => {
                  if (fromGuest) {
                    handlePortfolioClick(strategy);
                  } else {
                    let redirectState = {
                      path: "/strategy-details",
                      state: {
                        from: location.pathname,
                        strategyid: strategy.strategy_id,
                        showInvest: showInvest,
                        historyStack: [
                          ...(location.state?.historyStack || []),
                          location.pathname,
                        ],
                      },
                    };
                    sessionStorage.setItem(
                      "redirectAfterLogin",
                      JSON.stringify(redirectState)
                    );
                    navigate("/strategy-details", {
                      state: {
                        from: location.pathname,
                        strategyid: strategy.strategy_id,
                        showInvest: showInvest,
                        historyStack: [
                          ...(location.state?.historyStack || []),
                          location.pathname,
                        ],
                      },
                    });
                  }
                }}
                className="cursor-pointer text-sm font-medium text-gray-800 break-words leading-snug mb-1 underline"
              >
                Caprock Model Portfolio - {strategy.strategy_name}
              </div>

              {/* Balance */}
              <div className="text-xs text-green-700 font-semibold mt-2">
                Minimum Investment Amount: $
                {strategy.minimum_investment
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              </div>
            </div>
          ))}
        </div>
      </div>
      <EmailVerificationModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setEmail("");
          setFile(null);
          setUserName("");
          setSelectedCode("");
          setMobileNumber("");
          setEmailSent(false);
        }}
        title="Access Portfolio:"
        subtitle={`Caprock Model Portfolio - ${selectedPortfolio?.strategy_name}`}
        email={email}
        setEmail={setEmail}
        emailSent={emailSent}
        file={file}
        setFile={setFile}
        userName={userName}
        setUserName={setUserName}
        selectedCode={selectedCode}
        setSelectedCode={setSelectedCode}
        focus={focus}
        setFocus={setFocus}
        mobileNumber={mobileNumber}
        setMobileNumber={setMobileNumber}
        handleSendLink={handleSendLink}
        handleCodeChange={handleCodeChange}
      />
    </div>
  );
}
